<template>
  <history-timeline
    :filters="historyFilters"
    :items="historyItems"></history-timeline>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getPersonName } from 'best-modules/utils'
import { useDocumentAgreement } from '../documentAgreement'
import HistoryTimeline from '@/components/history-timeline/HistoryTimeline.vue'
import {
  HistoryTimelineFilter,
  HistoryTimelineItem,
} from '@/components/history-timeline/types'
import { DocumentAgreementLog } from '@/utils/types/documentAgreement'

defineOptions({
  name: 'DocumentAgreementHistory',
})

const { logs } = useDocumentAgreement()

const historyFilters: HistoryTimelineFilter[] = [
  { title: 'Усі', value: 'all' },
  { title: 'Візування', value: 'review' },
  { title: 'Погодження', value: 'approval' },
  { title: 'Доопрацювання', value: 'revision' },
  { title: 'Зміни', value: 'change' },
]

const resolveStatus = (
  log: DocumentAgreementLog
): { category: string; type: string; color: string; description: string } => {
  if (log.newStatusId === 1) {
    return {
      category: 'change',
      type: 'СТВОРЕННЯ',
      color: 'deep-purple',
      description: 'Чорновик',
    }
  }
  if (
    [1, 3].includes(log.oldStatusId) &&
    log.newStatusId === 3 &&
    log.isApproved
  ) {
    return {
      category: 'review',
      type: 'ВІЗУВАННЯ',
      color: 'info',
      description: 'Завізовано (Погодив документ)',
    }
  }
  if (
    [1, 3].includes(log.oldStatusId) &&
    log.newStatusId === 3 &&
    !log.isApproved
  ) {
    return {
      category: 'change',
      type: 'ЗМІНА',
      color: 'deep-purple',
      description: 'Додано',
    }
  }
  if (log.oldStatusId === 3 && log.newStatusId === 2) {
    return {
      category: 'revision',
      type: 'ДООПРАЦЮВАННЯ',
      color: 'warning',
      description: ['Доопрацювання документа', log.text]
        .filter(Boolean)
        .join(' '),
    }
  }
  if (log.oldStatusId === 2 && log.newStatusId === 3) {
    return {
      category: 'review',
      type: 'ВІЗУВАННЯ',
      color: 'info',
      description: ['Доопрацьовано', log.text].filter(Boolean).join(' '),
    }
  }
  if (log.newStatusId === 4) {
    return {
      category: 'approval',
      type: 'ПОГОДЖЕНО',
      color: 'success',
      description: 'Погоджено всіми',
    }
  }
  return {
    category: 'change',
    type: 'ЗМІНА',
    color: 'deep-purple',
    description: log.text ?? '',
  }
}

const historyItems = computed<HistoryTimelineItem[]>(() =>
  logs.value.map(log => {
    const info = resolveStatus(log)

    return {
      id: log.id,
      date: log.created_at,
      category: info.category,
      type: info.type,
      color: info.color,
      user: getPersonName(log.user),
      position: log.user?.post ?? '',
      description: info.description,
    }
  })
)
</script>
